import _extends from "@babel/runtime/helpers/esm/extends";
import PropTypes from 'prop-types';
import * as React from 'react';
import MuiTablePagination from '@mui/material/TablePagination';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 *
 * Demos:
 *
 * - [Table](https://ui-packages.isbuildingluma.com/ui-core/react-table/)
 *
 * API:
 *
 * - [TablePagination API](https://ui-packages.isbuildingluma.com/ui-core/api/table-pagination/)
 * - inherits [MuiTablePagination API](https://mui.com/material-ui/api/table-pagination/)
 */
const TablePagination = function TablePagination(props) {
  return /*#__PURE__*/_jsx(MuiTablePagination, _extends({}, props));
};
process.env.NODE_ENV !== "production" ? TablePagination.propTypes /* remove-proptypes */ = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit "TablePaginationProps.ts" and run "yarn proptypes"
  // ----------------------------------------------------------------------
  /**
   * @ignore
   */
  children: PropTypes.node
} : void 0;
export default TablePagination;